import React from "react";

const SubsectionList = ({
  subsections,
  selectedSubsection,
  onSubsectionSelect,
}) => {
  return (
    <div className="flex flex-wrap gap-5  p-2 text-[11px] font-normal border border-[#3BA2B91C] shadow-[0_0_25.2px_0_#3BA2B91F]">
      {subsections.length > 0 ? (
        subsections.map((sub, index) => (
          <div
            key={index}
            className={`p-3 rounded-xl cursor-pointer border transition-all duration-200  ${
              selectedSubsection !== sub._id
                ? "bg-[#E6EEEC]  shadow-md"
                : "bg-transparent text-black hover:bg-gray-100"
            }`}
            onClick={() => onSubsectionSelect(sub._id)}
          >
            {sub.name}
          </div>
        ))
      ) : (
        <p className="text-gray-500">No subsections found.</p>
      )}
    </div>
  );
};

export default SubsectionList;
